/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import { Text, Link } from '../uiold';
import { sizes, themeColors, hitSlop } from '../uiold/Constants';

type Props = ObjectOf<unknown>;
type State = {
  isShown: boolean;
};

export default class BrowserUpdateNotice extends Component<Props, State> {
  state: State = {
    isShown: 'ActiveXObject' in window,
  };

  render() {
    if (this.state.isShown) {
      return (
        <View style={styles.root}>
          <View style={styles.alertTextContainer}>
            <Text type="label">
              Did you know your internet browser is out of date and limiting
              your web experience? To get the best experience, we recommend you
              to upgrade to another web browser such as{' '}
              <Link
                href="https://www.microsoft.com/en-id/windows/microsoft-edge"
                style={styles.linkStyle}
              >
                Microsoft Edge
              </Link>
              ,{' '}
              <Link
                href="https://www.google.com/chrome/"
                style={styles.linkStyle}
              >
                Google Chrome
              </Link>{' '}
              or{' '}
              <Link
                href="https://www.mozilla.org/en-US/firefox/new/"
                style={styles.linkStyle}
              >
                Mozilla Firefox
              </Link>
              .
            </Text>
          </View>
          <DismissButton onPress={this._onClose} />
        </View>
      );
    }
    return null;
  }

  _onClose = () => {
    this.setState({ isShown: false });
  };
}

function DismissButton(props: { onPress: () => void }) {
  let { onPress } = props;
  return (
    <TouchableOpacity
      onPress={onPress}
      hitSlop={hitSlop}
      accessibilityRole="button"
    >
      <Text style={styles.dismissText}>×</Text>
    </TouchableOpacity>
  );
}

let styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    width: '100%',
    position: 'fixed' as any,
    top: 0,
    height: sizes.headerHeight,
    backgroundColor: themeColors.browserDialogBackground,
    padding: 10,
    paddingTop: 15,
    justifyContent: 'center',
  },
  linkStyle: {
    textDecorationLine: 'underline',
    color: themeColors.linkBlue,
  },
  alertTextContainer: {
    flex: 1,
  },
  dismissText: {
    fontSize: 28,
    lineHeight: 20,
    // color: themeColors.withOpacity,
    position: 'relative',
    top: -2,
  },
});
